/*
In the appointment grid for the desktop mode, we can have slots occupied by a
text describing a holiday. But depending on the slots occupied, the text -
which is displayed vertically, may or not be fully displayed, thus overflowing
its container. Should that be the case ,we will display a number and an
asterisk instead. Like "1*", "2*", etc.

This hook manages state for the legends, which are a list of strings that
should appear below the appointment grid to describe each of these
collapsed nomenclatures.
*/

import { useEffect, useState } from 'react'

export const indexOfSlot = (slot, list) => list.findIndex(({ holidayName }) => holidayName == slot.holidayName)

export const useLegendsByDate = (date) => {
  const [legends, setLegends] = useState([])

  const addLegend = (slot) => {
    setLegends((currentLegends) =>
      indexOfSlot(slot, currentLegends) == -1
        ? currentLegends.concat([slot]).sort((a, b) => a.start - b.start)
        : currentLegends
    )
  }

  useEffect(() => {
    if (legends.length > 0) {
      setLegends([])
    }
  }, [date])

  return [legends, addLegend]
}
